// extracted by mini-css-extract-plugin
module.exports = {"swipeSection":"_17949","swipeImage":"_5897"};